import { ListItem, Grid, Button, Divider } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import ReportOrder from './Enums/ReportOrder';
import FormAvatar from './FormAvatar';
import NarrativeExpander from './NarrativeExpander';
import PropertyStack from './PropertyStack';
import { EventReport } from '../core/api/clients';
import useGetFormMetadataByReportType from '../core/api/hooks/common/useGetFormMetadataByReportType';

interface IEventReportWrapper {
  eventReport: EventReport;
  color: string | null | undefined;
  onPrimaryClick: (eventReport: EventReport) => void;
  primaryText?: string;
}
function EventReportWrapper({ eventReport, color, onPrimaryClick, primaryText }: IEventReportWrapper) {
  const { id, aircraftNumber, landingAirport, flightSequence, employeeName, narrative, reportType, order } = eventReport;
  const { data: formMetadata } = useGetFormMetadataByReportType(reportType);
  return (
    <ListItem>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
        <Grid item xs={1}>
          <Stack direction="column" justifyContent="flex-start" alignItems="center" spacing={2}>
            <FormAvatar color={color ?? 'grey'} title={reportType} hasDecorator={order === ReportOrder.FER_Captain} />
            <Button
              size="small"
              endIcon={<LaunchIcon />}
              onClick={() => formMetadata?.route && window.open(`${formMetadata.route}/${id}/view`, '_blank', 'width=1000, height=700')?.focus()}
            >
              Open
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={9}>
          <Stack flexGrow={1} spacing={2}>
            <PropertyStack
              direction="row"
              spacing={2}
              divider={<Divider orientation="vertical" flexItem />}
              properties={{
                'Aircraft Number': aircraftNumber,
                'Landing Airport': landingAirport,
                'Sequence Number': `${flightSequence}`,
                'Created By': employeeName,
              }}
            />
            <NarrativeExpander narrative={narrative} />
          </Stack>
        </Grid>
        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => onPrimaryClick(eventReport)}>
            {primaryText ?? 'Primary'}
          </Button>
        </Grid>
      </Grid>
    </ListItem>
  );
}

export default EventReportWrapper;
